import { render } from "./TheNumberOfUsers.vue?vue&type=template&id=21158a9e&scoped=true&lang=html"
import script from "./TheNumberOfUsers.vue?vue&type=script&lang=js"
export * from "./TheNumberOfUsers.vue?vue&type=script&lang=js"

import "./TheNumberOfUsers.vue?vue&type=style&index=0&id=21158a9e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21158a9e"]])

export default __exports__